import { styled } from '@mui/material/styles';
import { Box, Typography, Paper, TableCell } from '@mui/material';

export const TableContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    overflowX: 'auto',
    marginTop: theme.spacing(2),
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
}));

export const TableTitle = styled(Typography)(({ theme }) => ({
    flex: '1 1 100%',
    color: 'inherit',
    ...theme.typography.subtitle1,
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(1.5),
    fontSize: '0.875rem',
    borderBottom: '1px solid #e0e0e0',
}));
